import { useQuery } from '@tanstack/react-query';
import useHttpClient from './useHttpClient';
import IContact from './models/contact';


export interface IQueryContactPayload {
    loading: boolean;
    error?: Error;
    contact?: IContact;
    refetchContact: () => void;
}

const useQueryContact = (contactId: number | string | null): IQueryContactPayload => {
    const httpClient = useHttpClient();

    const {
        data: contactData,
        error,
        isLoading: loading,
        refetch,
      } = useQuery<IContact>({
        queryKey: ['contact', contactId],
        queryFn: async () => {
            const response = await httpClient.get(`/contacts/${contactId}`);
            return response.data;
        },
        enabled: !!contactId,
    });

    return {
        error: error as Error | undefined,
        loading,
        contact: contactData,
        refetchContact: refetch,
    };
};

export default useQueryContact;